/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import type { ReactNode } from "react";
import { createContext, useContext } from "react";
import { useOrganizationDataState } from "./use-organization-data-state";
import type { OrganizationDataContextValue } from "./types";

export type { OrganizationDataContextValue } from "./types";

const OrganizationDataContext =
  createContext<OrganizationDataContextValue | null>(null);

const defaultContextValue: OrganizationDataContextValue = {
  organization: null,
  stats: null,
  isLoading: false,
  error: null,
  updateOrganization: async () => ({
    success: false,
    error: "Organization context not available",
  }),
  updateSettings: async () => ({
    success: false,
    error: "Organization context not available",
  }),
  validateSlug: async () => ({
    success: false,
    error: "Organization context not available",
  }),
  uploadLogo: async () => ({
    success: false,
    error: "Organization context not available",
  }),
  refreshOrganization: async () => {},
  refreshStats: async () => {},
};

export function OrganizationDataProvider({
  children,
}: {
  children: ReactNode;
}) {
  const value = useOrganizationDataState();
  return (
    <OrganizationDataContext.Provider value={value}>
      {children}
    </OrganizationDataContext.Provider>
  );
}

export function useOrganization(): OrganizationDataContextValue {
  const context = useContext(OrganizationDataContext);
  if (!context) {
    return defaultContextValue;
  }
  return context;
}
